import React, { Component } from "react";
import Loading from "../../Loading";
import {
  Paper,
  Card,
  CardHeader,
  CardText,
  FlatButton,
  Divider,
  Subheader,
  IconMenu,
  IconButton,
  MenuItem,
} from "material-ui";
import MoreVertIcon from "material-ui/svg-icons/navigation/more-vert";
import ProjectReportCard from "./ProjectReportCard";
import TasklistReportCard from "../tasklists/TasklistReportCard";
import TasklistTasks from "../tasklists/TasklistTasks";
import Formsy from "formsy-react";
import { FormsyText, FormsySelect } from "formsy-material-ui/lib";

export default class ProjectView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      project: [],
      projectTid: 0,
      styles: {
        centerStyle: {
          marginBottom: "1em",
          marginLeft: "auto",
          marginRight: "auto",
          width: "50%",
        },
      },
    };

    this.openTeamwork = this.openTeamwork.bind(this);
    this.renderReportCard = this.renderReportCard.bind(this);
    this.renderTasklist = this.renderTasklist.bind(this);
  }

  componentWillMount() {
    let idSplit = this.props.params._id.split("-");

    this.setState({ projectId: idSplit[1] });

    this.props.authFetchWorkorders(
      "/teamwork/getStaticTasklists?project=" + idSplit[1],
      this.props.token.jwt,
    );

    let data = {
      startDate: new Date(new Date().setDate(new Date().getDate() - 90)),
      endDate: new Date(),
      projectId: idSplit[1],
    };

    let url = "/api/teamwork/projectReports";
    let options = {
      method: "post",
      headers: {
        token: this.props.token.jwt,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ data }),
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        this.setState({ project: json });
      });
  }

  openTeamwork(tid) {
    //window.open(`https://deleo.teamwork.com/#projects/${tid}/tasks`)
    window.open(`https://1613976798262.teamwork.com/#projects/${tid}/tasks`);
  }

  renderReportCard(project, i) {
    return (
      <ProjectReportCard
        key={i}
        project={project}
        token={this.props.token}
        color={this.props.appbar.color}
      />
    );
  }

  renderTasklist(tasklist, i) {
    let idSplit = this.props.params._id.split("-");
    tasklist.startDate = new Date(new Date().setDate(new Date().getDate() - 7));
    tasklist.endDate = new Date();
    return (
      <Paper key={i}>
        <Card
          zDepth={2}
          style={{ backgroundColor: "#5C6BC0", marginTop: "0.45em" }}
        >
          <CardHeader
            title={tasklist.name}
            titleStyle={{ fontWeight: "bold", fontSize: "150%" }}
            actAsExpander={true}
            showExpandableButton={true}
          />
          <CardText
            expandable={true}
            style={{ backgroundColor: "#FAFAFA", margin: "0.5em" }}
          >
            <TasklistReportCard
              key={i}
              tasklist={tasklist}
              token={this.props.token}
              color={this.props.appbar.color}
            />
            <TasklistTasks
              projectId={idSplit[0]}
              tasklistId={tasklist.id}
              openDialog={this.props.openDialog}
              closeDialog={this.props.closeDialog}
              token={this.props.token}
            />
          </CardText>
        </Card>
      </Paper>
    );
  }

  render() {
    let { company, taskLists } = this.props.details;

    if (this.props.isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={this.props.appbar.color} />
          </center>
        </div>
      );
    } else {
      let { centerStyle } = this.state.styles;
      return (
        <div>
          <Paper
            className="container"
            zDepth={2}
            style={{
              marginTop: "2em",
              paddingTop: "1em",
              paddingBottom: "1em",
            }}
          >
            {/*<div style={centerStyle}>
							<h3>{this.props.details.company.name}</h3>
						</div>*/}
            <div>{this.state.project.map(this.renderReportCard)}</div>
            <center>
              <Divider style={{ marginTop: "1em", marginBottom: "1em" }} />
              <FlatButton
                label="Open Project in Teamwork"
                hoverColor="#9E9E9E"
                onClick={this.openTeamwork.bind(this, this.state.projectId)}
              />
              <Divider style={{ marginTop: "1em", marginBottom: "1em" }} />
            </center>
            <Subheader>Tasklists</Subheader>
            <div>{this.props.workOrders.map(this.renderTasklist)}</div>
          </Paper>
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./app/components/teamwork/projects/ProjectView.js